import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import { parseCalendarDate } from "./calendar-date.helper";
import ProductGroup from "./product-group.model";

export default class ProductGroupFactory
  implements ObjectBuilderInterface<ProductGroup> {
  public buildFromJSON(data: { [key: string]: any }): ProductGroup {
    const value = new ProductGroup(
      data.id,
      String(data.period),
      data.name,
      parseCalendarDate(data.internationalDueDate),
      parseCalendarDate(data.domesticDueDate),
      data.products.map((productPath: string) =>
        productPath.replace(/^\/products\//, "")
      )
    );

    (value as any).fCreatedAt = new Date(data.createdAt);
    (value as any).fUpdatedAt = new Date(data.updatedAt);

    value.isNew = false;

    return value;
  }
}
